<template>
  <div class="statistics">
    <div class="row">
      <div class="key">可入库:</div>
      <div class="val">{{ statistics.possible_num }}</div>
    </div>
    <div class="row">
      <div class="key">已到货:</div>
      <div class="val">{{ statistics.storage_num }}</div>
    </div>
    <div class="row">
      <div class="key">在库数:</div>
      <div class="val">{{ statistics.stock_num }}</div>
    </div>
    <div class="row">
      <div class="key">已出货:</div>
      <div class="val">{{ statistics.delivery_num }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    selectList: { type: Array },
  },
  computed: {
    statistics() {
      let total = {
        possible_num: 0,
        storage_num: 0,
        stock_num: 0,
        delivery_num: 0,
      }
      this.selectList.forEach(item => {
        total.possible_num += item.possible_num - 0
        total.storage_num += item.storage_num - 0
        total.stock_num += item.stock_num - 0
        total.delivery_num += item.delivery_num - 0
      })
      return total
    }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.row {
  display: flex;
  margin-bottom: 5px;
  color: #000;

  .key {
    width: 120px;
    margin-right: 10px
  }

  .val {
    color: #B4272D;
  }
}

/deep/.el-popover {
  background-color: pink !important;
}
</style>